import React, { Component } from 'react';
import './Chat.css';
import Header from '../Header';
import Options from '../Options';
import Bubble from '../Bubble';

class Chat extends Component {
  constructor(context, props) {
    super(context, props);
    let { messages } =  this.props;
    this.state = {messages: messages.slice(0, 1), callbacks: {}, realOptionsHeight: null, optionsHeight: null};
    this.addSeries(1, messages);
  }

  componentDidMount() {
    let { _chat, handleScroll, updateOptions } = this;
    updateOptions.bind(this)(this.state.realOptionsHeight);
    _chat.addEventListener('scroll', handleScroll.bind(this));
    _chat.addEventListener('mousewheel', handleScroll.bind(this));
    if ("ontouchmove" in window) {
      _chat.addEventListener("touchmove", handleScroll.bind(this));
    }
  }

  componentWillReceiveProps(nextProps) {
    let { messages } =  nextProps;
    let prevMessages = this.props.messages;
    let index = prevMessages.length;
    this.setState({messages: messages.slice(0, index + 1)});
    this.addSeries(index + 1, messages);
  }

  componentWillUpdate(nextProps, nextState) {
    let { realOptionsHeight } = nextState;
    if (realOptionsHeight) {
      this.updateOptions.bind(this)(realOptionsHeight);
    }
  }

  handleScroll() {
    let  { syntheticScroll } = this.state;
    if (syntheticScroll) {
      console.log('Synthetic scroll');
      this.setState({...this.state, syntheticScroll:false, animationRestricted: false});
      return false;
    }

    this.handleNaturalScroll();
  }

  handleNaturalScroll() {
    console.log('Natural scroll');
    if (this.isScrolledToBottom(this._chat)) {
      // console.log('scrolled to bottom');
      this.setState({...this.state, animationRestricted: false});
    } else {
      this.stopAnimation.bind(this)();
      this.setState({...this.state, animationRestricted: true});
    }
  }

  isScrolledToBottom(el) {
    return el.scrollTop >= el.scrollHeight - el.offsetHeight;
  }

  scrollBottom() {
    let { animationRestricted } = this.state;
    if (animationRestricted) {
      this.stopAnimation.bind(this)();
      return false;
    }
    let lastChildBottom = this._chat.lastChild.offsetTop + this._chat.lastChild.offsetHeight - this._chat.offsetHeight;
    if (this._chat) this._chat.scrollTop = lastChildBottom;
    // if (this._chat) this._chat.scrollTop = this._chat.scrollHeight - this._chat.offsetHeight;
    let animationID = requestAnimationFrame(this.scrollBottom.bind(this));
    this.setState({...this.state, animationID, syntheticScroll: true});
  }

  startAnimation() {
    // console.log('ANIMATION START');
    if (this.state.animationID) this.stopAnimation.bind(this)();
    let animationID = requestAnimationFrame(this.scrollBottom.bind(this));
    this.setState({...this.state, animationID});
  }

  stopAnimation() {
    // console.log('ANIMATION STOP');
    cancelAnimationFrame(this.state.animationID);
    this.setState({...this.state, animationID:false});
  }

  onUpdate() {
    if (this._chat) this._chat.scrollTop = this._chat.scrollHeight;
  }

  addSeries(index, nextMessages) {
    let { callbacks } = this.state;
    nextMessages.slice(index).forEach((message, i) => {
      let callback = function(){
        this.startAnimation.bind(this)();
        this.setState({messages:nextMessages.slice(0, i+index+1)});
      }.bind(this);
      callbacks[i+index - 1] = callback;
    });
  }

  setOptionsHeight(height) {
    this.setState({...this.state, realOptionsHeight: height});
  }

  updateOptions(height) {
    let adjustedHeight = height + 40;
    let delta = adjustedHeight - this._options.offsetHeight;
    if (delta > 0) {
      this.setState({...this.state, optionsHeight: adjustedHeight});
    } else {
      // this.setState({...this.state, optionsHeight: false});
    }
  }

  render() {
    let { messages, callbacks, optionsHeight } =  this.state;
    let { hidden } = this.props;
    let optionsStyle = optionsHeight ? {height: optionsHeight} : {};
    return (
      <div className={"Chat" + (hidden ? " Chat--hidden": "")} ref={(c)=> {this._chat = c;}}>
          <Header mobile={true} />
          <div className="Wrapper Chat__messages">
              {messages.map((message, i) => {
                if (message.type === "their") {
                  return <Bubble key={i} {...message} onAnimated={callbacks[i]}/>;
                } else {
                  return <Options key={i} options={message.options} selectOption={this.props.selectOption.bind(this)}
                  onAnimated={callbacks[i]}
                  setOptionsHeight={this.setOptionsHeight.bind(this)}
                  />
                }
              })}
          </div>
          <div className="Wrapper Chat__options" style={optionsStyle} ref={(o)=> {this._options = o;}}></div>
      </div>
    );
  }
}

export default Chat;



/** WEBPACK FOOTER **
 ** ./src/components/Chat/index.js
 **/